import type { NotificationPreferences } from "../types/models";
import { createIdempotencyKey } from "../lib/idempotency";
import { apiData, type Schema } from "./api";

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
  return apiData<Schema<"NotificationPreferencesResponseEnvelope">>("/notifications/preferences");
}

export async function updateNotificationPreferences(
  body: Schema<"UpdateNotificationPreferencesRequest">
): Promise<NotificationPreferences> {
  await apiData<Schema<"BooleanResponseEnvelope">, Schema<"UpdateNotificationPreferencesRequest">>("/notifications/preferences", {
    method: "PATCH",
    body
  });
  return getNotificationPreferences();
}

export async function addWebPushSubscription(body: Schema<"AddWebPushSubscriptionRequest">): Promise<void> {
  await apiData<Schema<"IDResponseEnvelope">, Schema<"AddWebPushSubscriptionRequest">>("/notifications/web-push-subscriptions", {
    method: "POST",
    body,
    idempotencyKey: createIdempotencyKey()
  });
}

export async function sendTestNotification(channel: "email" | "web_push"): Promise<void> {
  await apiData<Schema<"IDResponseEnvelope">, Schema<"TestNotificationRequest">>("/notifications/test", {
    method: "POST",
    body: { channel },
    idempotencyKey: createIdempotencyKey()
  });
}
